import { Search as SearchIcon } from "@mui/icons-material";
import { useState } from "react";

import styles from './adminSearch.module.css';

interface AdminSearchProps {
    searchTerm: string;
    width?: string;
    height?: string;
    handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
export const AdminSearch = ({ searchTerm, width, height, handleInputChange }: AdminSearchProps) => {
    const [isFocused, setIsFocused] = useState(false);

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };
    return (
        <div className={styles.searchContainer} style={{ width: width, height: height }}>
            {(!isFocused && !searchTerm) && <div className={styles.searchIcon}>
                <SearchIcon />
            </div>}
            <input
                type="text"
                value={searchTerm}
                onChange={handleInputChange}
                placeholder={isFocused ? "" : "Suche"}
                className={styles.searchInput}
                onFocus={handleFocus}
                onBlur={handleBlur}
            />
        </div>
    );
};